import * as React from 'react'
import { useMemo } from 'react'

import AccessTimeIcon from '@mui/icons-material/AccessTime'
import CalendarTodayIcon from '@mui/icons-material/CalendarToday'

import { formatTimeRange, formatWorkTime } from '@user/store/scheduling'
import { shortDateScheduling } from '@sales-center/common'
import Stack, { type StackProps } from '@mui/material/Stack'
import Typography from '@mui/material/Typography'

type AppointmentDateTimeProps = StackProps & {
  workTime: Date | null
  timeRange: string | null
}

export function AppointmentDateTime(props: AppointmentDateTimeProps) {
  const { workTime, timeRange, ...rest } = props

  const formattedDate = useMemo(() => shortDateScheduling(workTime), [workTime])

  const formattedRange = useMemo(() => {
    const formattedTimeRange = formatTimeRange(timeRange)
    const [, formattedTime] = formatWorkTime(workTime)

    return formattedTimeRange != null ? formattedTimeRange : formattedTime
  }, [timeRange, workTime])

  return (
    <Stack {...rest}>
      <Stack direction="row" alignItems="center">
        <CalendarTodayIcon fontSize="inherit" />
        <Typography variant="body2" ml={1}>
          {formattedDate}
        </Typography>
      </Stack>

      {!!formattedRange && (
        <Stack direction="row" alignItems="center">
          <AccessTimeIcon fontSize="inherit" />
          <Typography variant="body2" ml={1}>
            {formattedRange}
          </Typography>
        </Stack>
      )}
    </Stack>
  )
}
